import React from "react";
import { motion, useReducedMotion } from "framer-motion";
const BUMPS = 22;
function scallopPoints(): string {
  const pts: string[] = [];
  for (let i = 0; i < BUMPS * 2; i++) {
    const r = i % 2 === 0 ? 100 : 91;
    const a = Math.PI * i / BUMPS;
    pts.push(`${(Math.cos(a) * r).toFixed(2)},${(Math.sin(a) * r).toFixed(2)}`);
  }
  return pts.join(" ");
}
const points = scallopPoints();
interface SealBadgeProps {
  ring: string;
  center: React.ReactNode;
  className?: string;
}
export function SealBadge({
  ring,
  center,
  className = ""
}: SealBadgeProps) {
  const reduce = useReducedMotion();
  return <span className={`relative block ${className}`} data-id="element-623" data-mp="3cwsjgywar8wj">
      <motion.svg viewBox="-105 -105 210 210" className="h-full w-full" animate={reduce ? undefined : {
      rotate: 360
    }} transition={{
      duration: 24,
      ease: "linear",
      repeat: Infinity
    }} aria-hidden="true" data-id="element-624" data-mp="37wwi77ezhvko">
        <polygon points={points} fill="#e8573a" stroke="#e8573a" strokeWidth={10} strokeLinejoin="round" data-id="element-625" data-mp="1662utxyr8a24" />
        <circle r={74} fill="none" stroke="#f8f1df" strokeWidth={1.2} strokeDasharray="3 4" data-id="element-626" data-mp="2wh2tbejfy0zc" />
        <defs data-id="element-627" data-mp="30lsn8xujh5hm">
          <path id="seal-ring" d="M 0,0 m -61,0 a 61,61 0 1,1 122,0 a 61,61 0 1,1 -122,0" data-id="element-628" data-mp="30i4rrt5ja909" />
        </defs>
        <text fill="#f8f1df" fontSize="13" fontWeight={700} letterSpacing="3.2" fontFamily="Plus Jakarta Sans, sans-serif" data-id="element-629" data-mp="2mmkna2qjxtcd">
          <textPath href="#seal-ring" data-id="element-630" data-mp="3f9dp6ofogyny">{ring}</textPath>
        </text>
      </motion.svg>
      <span className="absolute inset-0 flex items-center justify-center text-center font-display uppercase leading-[0.9] text-cream" data-id="element-631" data-mp="3k88hcgzjbzkq">
        {center}
      </span>
    </span>;
}